// src/pages/Location.js
import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaClock, FaExternalLinkAlt, FaFacebook, FaInstagram, FaTiktok, FaSnapchat, FaReddit, FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

function Location() {
  // Google Maps embed URL (obtained from Google Maps -> Share -> Embed a map)
  const googleMapsEmbedUrl =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2486.8324742872794!2d0.3697044!3d51.4419877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8b7ae52f01cd9%3A0x14c3c99f95fd6f0d!2s24-25%20New%20Rd%2C%20Gravesend%20DA11%200AA%2C%20UK!5e0!3m2!1sen!2sus!4v1689862035736!5m2!1sen!2sus";

  // URL for "Open in Google Maps" link
  const addressQuery = encodeURIComponent("Kentech Phones, 24-25 New Rd, Gravesend DA11 0AA");
  const googleMapsDirectUrl = `https://www.google.com/maps/search/?api=1&query=${addressQuery}`;

  // --- Enhanced Styles ---
  const pageStyle = { padding: '3rem 1rem', backgroundColor: '#f8f9fa', color: '#6c757d' };
  const mainHeadingStyle = { fontSize: '2.5rem', color: '#007BFF', marginBottom: '0.5rem', fontWeight: 'bold', textShadow: '2px 2px 4px rgba(0,123,255,0.1)' };
  const subHeadingStyle = { fontSize: '1.2rem', color: '#6c757d', marginBottom: '3rem' };
  const sectionHeadingStyle = {
    fontSize: '1.6rem',
    color: '#007BFF',
    marginBottom: '1.5rem',
    fontWeight: 'bold',
    borderBottom: '3px solid #007BFF',
    paddingBottom: '0.75rem',
    display: 'inline-block',
    textAlign: 'center'
  };
  const addressStyle = {
    fontStyle: 'normal',
    lineHeight: '1.9',
    marginBottom: '2rem',
    color: '#6c757d',
    fontSize: '1.1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: '2px solid #007BFF',
    boxShadow: '0 2px 8px rgba(0,123,255,0.1)',
    textAlign: 'center'
  };
  const infoItemStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: '1.5rem',
    color: '#6c757d',
    gap: '15px',
    padding: '1rem',
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: '1px solid #dee2e6',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    textAlign: 'center'
  };
  const iconStyle = { color: '#007BFF', marginTop: '4px', flexShrink: 0, width: '24px', textAlign: 'center', fontSize: '1.2rem' };
  const linkStyle = { color: '#007BFF', textDecoration: 'none', fontWeight: '500', borderBottom: '2px solid transparent', transition: 'border-color 0.3s' };
  const mapContainerStyle = {
    width: '100%',
    maxWidth: '100%',
    height: '500px',
    marginBottom: '2rem',
    overflow: 'hidden',
    borderRadius: '12px',
    border: '3px solid #007BFF',
    boxShadow: '0 4px 12px rgba(0,123,255,0.2)'
  };

  const isMapUrlPlaceholder = googleMapsEmbedUrl === "YOUR_Maps_EMBED_API_SRC_HERE";

  return (
    <main className="page-container location-page" style={pageStyle}>
      <header className="text-center mb-5">
        <h1 style={mainHeadingStyle}>Our Location</h1>
        <p style={subHeadingStyle}>Visit us for expert repairs in Gravesend.</p>
      </header>

      <div className="row" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Left Column: Address & Info */}
        <div className="col-md-6 mb-4 mb-md-0">
          <section aria-labelledby="address-heading" style={{ marginBottom: '2rem', textAlign: 'center' }}>
            <h2 id="address-heading" style={sectionHeadingStyle}>Store Address</h2>
            <address style={addressStyle}>
              <strong style={{ fontSize: '1.2rem', color: '#007BFF' }}>Kentech Phones</strong><br />
              24-25 New Rd,<br />
              Gravesend DA11 0AA
            </address>
            <div style={infoItemStyle}>
              <FaPhoneAlt style={{ ...iconStyle, marginTop: 0 }} />
              <div>
                <strong>Phone:</strong><br />
                <a href="tel:07944859580" style={linkStyle}>07944 859580</a>
              </div>
            </div>
            <div style={{ ...infoItemStyle, padding: '1.5rem' }}>
              <strong style={{ fontSize: '1.1rem', color: '#007BFF', marginBottom: '1rem' }}>Follow Us</strong>
              <div style={{ display: 'flex', gap: '1rem', fontSize: '1.8rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                <a href="https://facebook.com/kentechphones" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#6c757d', transition: 'all 0.3s', padding: '0.5rem', borderRadius: '50%', backgroundColor: '#f8f9fa' }}
                   onMouseEnter={(e) => { e.currentTarget.style.color = '#007BFF'; e.currentTarget.style.backgroundColor = '#e3f2fd'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = '#6c757d'; e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.transform = 'scale(1)'; }}>
                  <FaFacebook />
                </a>
                <a href="https://instagram.com/kentechphones" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#6c757d', transition: 'all 0.3s', padding: '0.5rem', borderRadius: '50%', backgroundColor: '#f8f9fa' }}
                   onMouseEnter={(e) => { e.currentTarget.style.color = '#007BFF'; e.currentTarget.style.backgroundColor = '#e3f2fd'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = '#6c757d'; e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.transform = 'scale(1)'; }}>
                  <FaInstagram />
                </a>
                <a href="https://tiktok.com/@kentechphones" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#6c757d', transition: 'all 0.3s', padding: '0.5rem', borderRadius: '50%', backgroundColor: '#f8f9fa' }}
                   onMouseEnter={(e) => { e.currentTarget.style.color = '#007BFF'; e.currentTarget.style.backgroundColor = '#e3f2fd'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = '#6c757d'; e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.transform = 'scale(1)'; }}>
                  <FaTiktok />
                </a>
                <a href="https://snapchat.com/add/kentechphones" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#6c757d', transition: 'all 0.3s', padding: '0.5rem', borderRadius: '50%', backgroundColor: '#f8f9fa' }}
                   onMouseEnter={(e) => { e.currentTarget.style.color = '#007BFF'; e.currentTarget.style.backgroundColor = '#e3f2fd'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = '#6c757d'; e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.transform = 'scale(1)'; }}>
                  <FaSnapchat />
                </a>
                <a href="https://twitter.com/kentechphones" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#6c757d', transition: 'all 0.3s', padding: '0.5rem', borderRadius: '50%', backgroundColor: '#f8f9fa' }}
                   onMouseEnter={(e) => { e.currentTarget.style.color = '#007BFF'; e.currentTarget.style.backgroundColor = '#e3f2fd'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = '#6c757d'; e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.transform = 'scale(1)'; }}>
                  <FaXTwitter />
                </a>
                <a href="https://reddit.com/r/kentechphones" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#6c757d', transition: 'all 0.3s', padding: '0.5rem', borderRadius: '50%', backgroundColor: '#f8f9fa' }}
                   onMouseEnter={(e) => { e.currentTarget.style.color = '#007BFF'; e.currentTarget.style.backgroundColor = '#e3f2fd'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = '#6c757d'; e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.transform = 'scale(1)'; }}>
                  <FaReddit />
                </a>
                <a href="https://wa.me/447944859580" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#6c757d', transition: 'all 0.3s', padding: '0.5rem', borderRadius: '50%', backgroundColor: '#f8f9fa' }}
                   onMouseEnter={(e) => { e.currentTarget.style.color = '#007BFF'; e.currentTarget.style.backgroundColor = '#e3f2fd'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                   onMouseLeave={(e) => { e.currentTarget.style.color = '#6c757d'; e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.transform = 'scale(1)'; }}>
                  <FaWhatsapp />
                </a>
              </div>
            </div>
            <div style={infoItemStyle}>
              <FaMapMarkerAlt style={{ ...iconStyle, marginTop: 0 }} />
              <div>
                <strong>Directions:</strong><br />
                <a href={googleMapsDirectUrl} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                  Open in Google Maps <FaExternalLinkAlt size={12} style={{ marginLeft: '4px' }} />
                </a>
              </div>
            </div>
          </section>
          <section aria-labelledby="hours-heading" style={{ marginTop: '2rem', textAlign: 'center' }}>
            <h2 id="hours-heading" style={sectionHeadingStyle}>Opening Hours</h2>
            <div style={{ ...infoItemStyle, backgroundColor: '#e3f2fd', borderColor: '#007BFF' }}>
              <FaClock style={{ ...iconStyle, marginTop: 0 }} />
              <div style={{ lineHeight: '1.8' }}>
                <strong style={{ color: '#007BFF' }}>Available:</strong> 24/7<br />
                <strong style={{ color: '#007BFF' }}>Contact us at:</strong> 9am to 9pm
              </div>
            </div>
          </section>
        </div>

        {/* Right Column: Map */}
        <div className="col-md-6" style={{ textAlign: 'center' }}>
          <h2 style={{ ...sectionHeadingStyle, marginBottom: '1.5rem' }}>Find Us On The Map</h2>
          <div style={mapContainerStyle}>
            {isMapUrlPlaceholder ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  border: '1px dashed #ccc',
                  backgroundColor: '#f8f9fa',
                  color: '#6c757d',
                  textAlign: 'center',
                  padding: '1rem'
                }}
              >
                Map cannot be displayed. Please configure the Google Maps Embed URL in the code.
              </div>
            ) : (
              <iframe
                title="Kentech Phones - Gravesend Location"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={googleMapsEmbedUrl}
              ></iframe>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default Location;
